import React from 'react';
import { Sparkles } from 'lucide-react';
import type { Product } from '../types';
import CircularProductCard from './CircularProductCard';

interface InnovationSectionProps {
  products: Product[];
}

const InnovationSection: React.FC<InnovationSectionProps> = ({ products }) => (
  <section id="innovacion" className="relative overflow-hidden bg-white py-24">
    <div className="absolute inset-0 bg-cabina-cream bg-pattern opacity-30" aria-hidden="true" />

    <div className="container relative z-10 mx-auto px-6">
      <div className="mb-20 text-center">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-cabina-red/10 bg-cabina-cream px-4 py-1.5 shadow-sm">
          <Sparkles size={14} className="animate-pulse text-cabina-red" />
          <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-600">
            Tecnología de vanguardia
          </span>
        </span>

        <h2 className="mb-6 font-serif text-4xl font-bold italic text-black md:text-6xl">
          Productos Innovadores
        </h2>

        <div className="mx-auto mb-6 h-1 w-16 rounded-full bg-cabina-red/20" />

        <p className="mx-auto max-w-2xl text-lg leading-relaxed text-gray-500">
          Experiencias visuales que rompen moldes, combinando{' '}
          <span className="font-bold text-cabina-red">elegancia</span> con pura{' '}
          <span className="font-bold text-cabina-red">diversión</span>.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-x-3 gap-y-6 sm:gap-x-8 sm:gap-y-12 md:gap-16 lg:grid-cols-4 lg:gap-x-10">
        {products.map((product) => (
          <CircularProductCard key={product.id} product={product} variant="innovation" />
        ))}
      </div>
    </div>
  </section>
);

export default InnovationSection;
